import { Platform, StyleSheet } from 'react-native'

import { moderateScale } from '../../styles/sizes'
import { fontFamily } from '../../theme/fontFamily'

export const styles = StyleSheet.create({
  container: {
    height: Platform.OS === 'ios' ? 85 : 45,
    flexDirection: 'row',
    backgroundColor: 'rgb(49, 22, 94)',
    borderBottomWidth: 0.2,
    borderBottomColor: '#fff',
    paddingBottom: 10
  },
  leftView: {
    flex: 1,
    justifyContent: 'flex-end'
    // justifyContent: Platform.OS === 'android' ? 'center' : 'flex-end'
  },
  middleView: {
    flex: 2,
    justifyContent: 'flex-end',
    alignItems: 'center'
  },
  titleView: {
    height: 26,
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row'
  },
  title: {
    fontSize: moderateScale(18),
    fontFamily: fontFamily.sfProDisplayBold,
    color: '#fff',
    textAlignVertical: 'center',
    paddingTop: 2
  },
  rightContainer: {
    flex: 1,
    justifyContent: 'flex-end',
    alignItems: 'center'
  },
  rightView: {
    height: 26,
    width: '100%',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flexDirection: 'row',
    paddingRight: 12,
    paddingTop: 5
  },
  chatIcon: {
    width: 24,
    height: 22,
    resizeMode: 'contain',
    marginRight: 7
  }
})
